import { Link } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import { LynxLinkProps } from "./LynxLinkProps";
import { lynxLinkStyles } from "./LynxLinkStyles";

export function LynxLink(props: LynxLinkProps) {
    const { size = "standard" } = props;

    const classes = lynxLinkStyles({ size });
    const linkClassName = clsx(classes.root, props.className);

    return (
        <span className={props.containerClassName}>
            <Link {...props} className={linkClassName} />
        </span>
    );
}
